// extracted by mini-css-extract-plugin
export default {"summary":"Item_summary__x1zDj","formula":"Item_formula__N7bQM"};